export enum AccessInheritanceDecision {
  Inherit = 'Inherit',
  LeaveUnchanged = 'LeaveUnchanged',
  Cancel = 'Cancel',
}
